// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-39f5bfc9] {\n  color: gray;\n  font-weight: 300;\n}", ""]);
// Exports
module.exports = exports;
